import { defineEffect } from '../../../core/effect';

/**
 * **対象に取る（場のカード）**（Issue #571。指示書 `../direction/become_target.md`）。
 *
 * 対象のカードに**照準の枠**（四隅の括弧）を**盤に置く**（`targetSight`）。締まる動き・脈は印そのものが
 * 置かれてからの時間で描く（`../fx/targetSight.js`）ので、**帯の中の絵は無い**（帯が終わっても枠はそのまま残り、継ぎ目が無い）。
 *
 * ```
 * 0     照準の枠が外から締まる（1.45 倍 → 1 倍。最後の 2 フレームだけ白く硬く）
 * 200   締まった枠が 2 回脈打つ
 * 500   帯の終わり。枠は盤に残り、控えめに脈打ち続ける
 * ```
 *
 * - **どのリンクの対象か**: この瞬間の `chain_stack` の一番上（今発動しているリンク）。色はそのリンクを発動したプレイヤーの色
 * - 印の key は `<チェーンの番号>:<カードの uid>`。**同じカードに複数のリンクの枠があれば入れ子**（後のリンクほど外側。角に番号）
 * - 消えるのは: そのリンクの `chain_solved`（`effects/chain_solved.js`）/ 無効にされたリンクの `chain_solving`（`chain_solved` が来ない）/
 *   念のため `chain_end` で全部。**カードが場を離れたら描かない**（`drawObjects.js::targetSight`）
 * - **場以外（墓地など）が対象のとき**（状況 `elsewhere`）は `become_target_elsewhere_effect.js`（Issue #597。同じ印を置き場の横に置く）
 * - 状況（`field` / `elsewhere`）と `chain` / `player` / `targets` は分岐レイヤー（`editorPorts/duelSituations/become_target.js`）が payload に付ける（Issue #589）
 */
export const D = 500;

export default defineEffect({
  situation: 'become_target_field',
  role: 'effect',
  label: '対象に取る（場）',
  color: '#ff5a3c',
  duration: () => D,
  places: ({ payload }) => (payload?.targets ?? []).map((c) => ({
    mark: 'targetSight',
    key: `${payload.chain}:${c.uid}`,
    at: { card: c.uid },
    data: { uid: c.uid, chain: payload.chain, player: payload.player === 1 ? 1 : 0 },
  })),
  sounds: () => [{ at: 170, name: 'set_card', gain: 0.45 }],
}, 'become_target_field_effect.js');
